import { render } from "./PageDecorations.vue?vue&type=template&id=3af6fdd6"
import script from "./PageDecorations.vue?vue&type=script&lang=js"
export * from "./PageDecorations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__